<div class="card list mb-0">
    <div class="card-body py-0">
        <div class="row">
            <div class="col-xl-4 col-lg-4">
                <img class="hubriseimg pr-2" src="/assets/img/HubRise.png" width="100%" style="max-width: 180px;">
                <app-help-icon [helpPageName]="helpUrl"></app-help-icon>
            </div>
            <div class="col-xl-8 col-lg-8 hr-margin">

                <div class="row" *ngIf="isDashboard && !isConnected">
                    <div class="italic col-lg-12 mb-2 explanation">
                        {{ 'admin.store.setting.integrations.shareDataWithOtherApplications' | translate }}
                    </div>
                    <div class="col-lg-12">
                        <div class="d-flex align-items-center justify-content-between p-0">
                            <button type="button" class="btn btn-primary mt-2" (click)="connectToHubrise()">
                                <i class="fa fa-link mr-2" title="link"></i>{{'admin.store.setting.connect' |
                                translate}}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="!isDashboard && isConnected">
                    <div class="col-lg-12">
                        <div class="col-lg-12">
                            <form [formGroup]="hubriseSettingsForm">
                                <div class="row d-flex align-items-center">
                                    <div class="form-group col-12 p-0">
                                        <span class="italic mr-4 mb-3">
                                            {{ 'admin.store.setting.integrations.connectedToHubrise' | translate }}
                                        </span>
                                    </div>
                                    <div class="form-row col-12 p-0 mb-4">
                                        <span class="col-sm-3">{{ 'admin.store.location.location' | translate }}:</span>
                                        <span class="col-sm-9">{{ hubriseSettingsForm.get('HUBRISE_LOCATION_NAME').value
                                            }}</span>
                                    </div>
                                    <div class="form-row col-12 p-0 mb-4">
                                        <span class="col-sm-3">{{ 'admin.store.settings.catalog.title' | translate
                                            }}:</span>
                                        <span class="col-sm-9">{{ hubriseSettingsForm.get('HUBRISE_CATALOG_NAME').value
                                            }}</span>
                                    </div>
                                    <div class="form-row col-12 p-0 mb-4">
                                        <span class="col-sm-3">{{ 'admin.store.setting.integrations.hubriseCustomerList'
                                            | translate }}:</span>
                                        <span class="col-sm-9">{{
                                            hubriseSettingsForm.get('HUBRISE_CUSTOMER_LIST_NAME').value }}</span>
                                    </div>
                                    <div class="form-group row col-md-12 mb-4">
                                        <div class="mr-5">
                                            <a class="btn btn-primary active" href="https://manager.hubrise.com/"
                                                target="_blank">
                                                {{ 'admin.store.setting.integrations.goToHubrise' | translate }}
                                            </a>
                                        </div>

                                    </div>
                                    <div class="form-grouprow col-md-12 mt-3">
                                        <button type="button" class="btn btn-danger float-right"
                                            (click)="disconnectFromHubrise()">
                                            <i class="fa-solid fa-link-slash mr-2 fs-20"></i>{{'admin.store.disconnect' | translate}}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
